import {
  configureCheckboxActionButton,
  configureCheckAllCheckbox,
} from '../../components/checkbox'
import { configureDateRangeFilters } from '../../components/filter_date_range'

function initApplicationList() {
  const buttonExportSelected = document.getElementById(
    'btn-export-selected',
  ) as HTMLButtonElement
  const checkboxes = document.getElementsByName(
    'application',
  ) as NodeListOf<HTMLInputElement>
  const selectAll = document.getElementById('select-all') as HTMLInputElement

  configureCheckboxActionButton(buttonExportSelected, checkboxes)
  configureCheckAllCheckbox(selectAll, checkboxes, buttonExportSelected)
  configureDateRangeFilters()
}

export { initApplicationList }
